import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Divider,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { adminLogout } from "../../../../redux/action/action";
import { useStyles } from "./AdminBar.css";

class AdminBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false,
    };
  }

  handleMenu = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
      open: false,
    });
  };

  handleLogout = () => {
    this.props.adminLogout();
  };

  render() {
    const { classes } = this.props;
    return (
      <AppBar position="fixed" elevation={0} className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={this.props.handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Digi-Book
          </Typography>
          <div style={{ flexGrow: 1 }} />
          <div className={classes.sectionDesktop}>
            <IconButton
              color="inherit"
              onClick={this.handleMenu}
              style={{ outline: "none" }}
            >
              <AccountCircleIcon />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              color="inherit"
              onClick={this.handleMenu}
              style={{ outline: "none" }}
            >
              <MoreVertIcon />
            </IconButton>
          </div>
          <Menu
            id="menu-appbar"
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={this.state.open}
            onClose={this.handleClose}
          >
            <Typography
              variant="h5"
              style={{ textAlign: "center", outline: "none" }}
            >
              <AccountCircleIcon />
            </Typography>
            <Divider />
            <MenuItem
              onClick={this.handleLogout}
              style={{ paddingLeft: 40, paddingRight: 40 }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AdminBar)));
